// extracted by mini-css-extract-plugin
export default {"officeItem":"OfficesPhones_modal_officeItem__4RX8J","name":"OfficesPhones_modal_name__4uJ9n","phone":"OfficesPhones_modal_phone__XoHB8"};